import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";
import { setContext } from '@apollo/client/link/context';

let endpoint = process.env.DATOCMS_API_URL;

if (process.env.DATOCMS_ENVIRONMENT && process.env.DATOCMS_ENVIRONMENT !== "") {
    endpoint += `/environments/${process.env.DATOCMS_ENVIRONMENT}`;
}

const httpLink = createHttpLink({
    uri: endpoint,
});

const authLink = setContext((_, { headers }) => {
    const token = process.env.DATOCMS_API_TOKEN;
    // return the headers to the context so httpLink can read them
    return {
        headers: {
            ...headers,
            authorization: token ? `Bearer ${token}` : "",
        }
    }
});

const options = {
    resultCaching: false // process.env.NODE_ENV === 'production',
}

const client = new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache(options),
});

export default client;